import React, { useState } from 'react';

function Footer({ setCurrentPage }) {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 4000);
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        {/* Main Footer */}
        <div className="footer-grid">
          {/* Brand Column */}
          <div className="footer-col footer-brand-col">
            <h3 className="footer-logo"><img src="/logo-icon.svg" alt="" style={{ width: 28, height: 28, borderRadius: 6, verticalAlign: 'middle', marginRight: 8 }} />GroceryHub</h3>
            <p className="footer-tagline">Your one-stop shop for fresh, quality groceries delivered straight to your doorstep. Serving communities with care since 2024.</p>
            <div className="footer-social">
              <a href="#!" className="social-link" aria-label="Facebook">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </a>
              <a href="#!" className="social-link" aria-label="Twitter">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
              <a href="#!" className="social-link" aria-label="Instagram">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul className="footer-links-list">
              <li><button onClick={() => setCurrentPage('home')}>Home</button></li>
              <li><button onClick={() => setCurrentPage('products')}>Products</button></li>
              <li><button onClick={() => setCurrentPage('cart')}>Shopping Cart</button></li>
              <li><button onClick={() => setCurrentPage('myorders')}>My Orders</button></li>
            </ul>
          </div>

          {/* Categories */}
          <div className="footer-col">
            <h4>Categories</h4>
            <ul className="footer-links-list">
              <li><button onClick={() => setCurrentPage('products')}>🥬 Fresh Produce</button></li>
              <li><button onClick={() => setCurrentPage('products')}>🧀 Dairy</button></li>
              <li><button onClick={() => setCurrentPage('products')}>🌾 Punjabi Specials</button></li>
              <li><button onClick={() => setCurrentPage('products')}>🍪 Snacks</button></li>
              <li><button onClick={() => setCurrentPage('products')}>🧺 Household</button></li>
            </ul>
          </div>

          {/* Contact & Newsletter */}
          <div className="footer-col">
            <h4>Stay Connected</h4>
            <div className="footer-contact-items">
              <div className="footer-contact-item">
                <span>📍</span> <span>123 Market Street, Toronto, ON</span>
              </div>
              <div className="footer-contact-item">
                <span>📞</span> <span>1-800-GROCERY</span>
              </div>
              <div className="footer-contact-item">
                <span>✉️</span> <span>support@groceryhub.com</span>
              </div>
              <div className="footer-contact-item">
                <span>🕐</span> <span>Mon–Sat: 8AM – 10PM</span>
              </div>
            </div>
            <div className="footer-newsletter">
              <p>Get weekly deals and updates:</p>
              {subscribed ? (
                <div className="newsletter-success">✓ Thanks for subscribing!</div>
              ) : (
                <div className="newsletter-form-wrapper">
                  <input
                    type="email"
                    placeholder="Your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="newsletter-input"
                  />
                  <button className="newsletter-btn" onClick={handleSubscribe}>→</button>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <div className="footer-bottom-inner">
            <p>&copy; 2026 GroceryHub. All rights reserved.</p>
            <p className="footer-credit">Group 3 — Web Development Capstone</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;